export { setAssetPath, setPlatformOptions } from '@stencil/core/internal/client';
export { C as ColumnType, SafTable, T as TableDensity, defineCustomElement as defineCustomElementSafTable } from './saf-table.js';
export { SafTag, T as TagColors, a as TagVariant, defineCustomElement as defineCustomElementSafTag } from './saf-tag.js';
export { T as TypographyColors, a as TypographyElements, b as TypographyVariants } from './saf-typography.types.js';
export { I as ItemAlignments, T as TextAlignments } from './types.js';
export { a as ButtonSize, B as ButtonVariants, I as IconPosition } from './saf-button2.js';
export { C as CardBackgroundPatterns, a as CardLayout, b as CardVariants } from './saf-card.types.js';
export { D as DividerOrientation, a as DividerVariant } from './saf-divider2.js';
export { E as Effects, SafEffects, defineCustomElement as defineCustomElementSafEffects } from './saf-effects.js';
export { F as FormElement, a as FormVariant, I as InputType, R as RadioCheckboxGroupMaxColumns, b as RadioCheckboxGroupOrientation, V as ValidationState } from './forms.js';
export { L as LinkVariants } from './saf-link.types.js';
export { SafPaper, S as SafPaperBackground, a as SafPaperPatternSizes, b as SafPattern, c as SafPatternPosition, defineCustomElement as defineCustomElementSafPaper } from './saf-paper.js';
import { setMode } from '@stencil/core';
export { SafAccordion, defineCustomElement as defineCustomElementSafAccordion } from './saf-accordion.js';
export { SafAccordionItem, defineCustomElement as defineCustomElementSafAccordionItem } from './saf-accordion-item.js';
export { SafAccordionPanel, defineCustomElement as defineCustomElementSafAccordionPanel } from './saf-accordion-panel.js';
export { SafBackToTop, defineCustomElement as defineCustomElementSafBackToTop } from './saf-back-to-top.js';
export { SafBreadcrumbs, defineCustomElement as defineCustomElementSafBreadcrumbs } from './saf-breadcrumbs.js';
export { SafButton, defineCustomElement as defineCustomElementSafButton } from './saf-button.js';
export { SafCard, defineCustomElement as defineCustomElementSafCard } from './saf-card.js';
export { SafCardMedia, defineCustomElement as defineCustomElementSafCardMedia } from './saf-card-media.js';
export { SafCheckboxGroup, defineCustomElement as defineCustomElementSafCheckboxGroup } from './saf-checkbox-group.js';
export { SafChip, defineCustomElement as defineCustomElementSafChip } from './saf-chip.js';
export { SafComparisonMatrix, defineCustomElement as defineCustomElementSafComparisonMatrix } from './saf-comparison-matrix.js';
export { SafDivider, defineCustomElement as defineCustomElementSafDivider } from './saf-divider.js';
export { SafForm, defineCustomElement as defineCustomElementSafForm } from './saf-form.js';
export { SafIcon, defineCustomElement as defineCustomElementSafIcon } from './saf-icon.js';
export { SafInputPassword, defineCustomElement as defineCustomElementSafInputPassword } from './saf-input-password.js';
export { SafInputTel, defineCustomElement as defineCustomElementSafInputTel } from './saf-input-tel.js';
export { SafInputText, defineCustomElement as defineCustomElementSafInputText } from './saf-input-text.js';
export { SafLink, defineCustomElement as defineCustomElementSafLink } from './saf-link.js';
export { SafMedia, defineCustomElement as defineCustomElementSafMedia } from './saf-media.js';
export { SafMenu, defineCustomElement as defineCustomElementSafMenu } from './saf-menu.js';
export { SafMenuItem, defineCustomElement as defineCustomElementSafMenuItem } from './saf-menu-item.js';
export { SafModal, defineCustomElement as defineCustomElementSafModal } from './saf-modal.js';
export { SafNavOption, defineCustomElement as defineCustomElementSafNavOption } from './saf-nav-option.js';
export { SafPagination, defineCustomElement as defineCustomElementSafPagination } from './saf-pagination.js';
export { SafPriceRange, defineCustomElement as defineCustomElementSafPriceRange } from './saf-price-range.js';
export { SafRadioButtonGroup, defineCustomElement as defineCustomElementSafRadioButtonGroup } from './saf-radio-button-group.js';
export { SafRadioCheckbox, defineCustomElement as defineCustomElementSafRadioCheckbox } from './saf-radio-checkbox.js';
export { SafRotatorContent, defineCustomElement as defineCustomElementSafRotatorContent } from './saf-rotator-content.js';
export { SafRotatorControls, defineCustomElement as defineCustomElementSafRotatorControls } from './saf-rotator-controls.js';
export { SafScrollProgress, defineCustomElement as defineCustomElementSafScrollProgress } from './saf-scroll-progress.js';
export { SafSelect, defineCustomElement as defineCustomElementSafSelect } from './saf-select.js';
export { SafShareLinks, defineCustomElement as defineCustomElementSafShareLinks } from './saf-share-links.js';
export { SafStickyNav, defineCustomElement as defineCustomElementSafStickyNav } from './saf-sticky-nav.js';
export { SafSvg, defineCustomElement as defineCustomElementSafSvg } from './saf-svg.js';
export { SafTab, defineCustomElement as defineCustomElementSafTab } from './saf-tab.js';
export { SafTabItem, defineCustomElement as defineCustomElementSafTabItem } from './saf-tab-item.js';
export { SafTabPanel, defineCustomElement as defineCustomElementSafTabPanel } from './saf-tab-panel.js';
export { SafTextarea, defineCustomElement as defineCustomElementSafTextarea } from './saf-textarea.js';
export { SafToast, defineCustomElement as defineCustomElementSafToast } from './saf-toast.js';
export { SafTypography, defineCustomElement as defineCustomElementSafTypography } from './saf-typography.js';

/**
 * @public
 */
var RatioEnum;
(function (RatioEnum) {
  RatioEnum["circular"] = "circular";
  RatioEnum["landscapeLarge"] = "landscape-large";
  RatioEnum["landscapeMedium"] = "landscape-medium";
  RatioEnum["landscapeSmall"] = "landscape-small";
  RatioEnum["portraitLarge"] = "portrait-large";
  RatioEnum["portraitSmall"] = "portrait-small";
  RatioEnum["square"] = "square";
})(RatioEnum || (RatioEnum = {}));

function appGlobalScript () {
  setMode(elm => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return 'lightDOM';
  });
}

const globalScripts = appGlobalScript;

globalScripts();

export { RatioEnum };

